import React from "react";
import MainContent from "../../components/mainContent/MainContent";
import GestionAsistencialContent from "./components/GestionAsistencialContent";

export default function GestionAsistencial() {
  return (
    <>
      <MainContent
        component={<GestionAsistencialContent />}
        titulo={"Gestión asistencial"}
        noBackground
        tableMaxWidth
      />
    </>
  );
}
